<template>
  <div class="loader-wrapper">
    <div class="p-progress-spinner" :class="{small: isSmall}" role="alert" aria-busy="true">
      <svg class="p-progress-spinner-svg" viewBox="25 25 50 50">
        <circle class="p-progress-spinner-circle-border" cx="50" cy="50" r="20" fill="none" strokeMiterlimit="10" />
        <circle class="p-progress-spinner-circle" cx="50" cy="50" r="20" fill="none" strokeMiterlimit="10" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  size: {type: String, default: ''}
});

const isSmall = computed(() => props.size === 'small');
</script>

<style lang="scss" scoped>

.loader-wrapper {
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: center;
}

.p-progress-spinner {
  position: relative;
  margin: 0 auto;
  width: toRem(100);
  height: toRem(100);
  display: inline-block;

  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }

  &.small {
    width: toRem(30);
    height: toRem(30);
  }
}

.p-progress-spinner-svg {
  animation: p-progress-spinner-rotate 3s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.p-progress-spinner-circle-border {
  stroke-dashoffset: 0;
  stroke: #d8ebff;
  stroke-linecap: round;
  stroke-width: 3px;
}

.p-progress-spinner-circle {
  stroke-dasharray: 89, 200;
  stroke-dashoffset: 0;
  stroke: #1890ff;
  animation: p-progress-spinner-dash 2s ease-in-out infinite;
  stroke-linecap: round;
  stroke-width: 3px;
  filter: drop-shadow(0px 0px 3px rgba(24, 144, 255, 0.4));
}

@keyframes p-progress-spinner-rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes p-progress-spinner-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
@keyframes p-progress-spinner-color {
  100%,
  0% {
    stroke: #d62d20;
  }
  40% {
    stroke: #0057e7;
  }
  66% {
    stroke: #008744;
  }
  80%,
  90% {
    stroke: #ffa700;
  }
}

</style>
